import React, { useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { Spinner } from '@/components/spinner';
import { useAppContext } from '@/context/app';
import { UsersReportWizardStep1 } from './Step1';
import { cleanWizardData, WizardData } from './Model';
import { useWizard, WizardProvider } from '@/common/wizard/wizard';
import { UseFormReturn } from 'react-hook-form';
import { addServerErrors } from '@/components/forms/common/FormBase';
import { UsersReportWizardResult } from './Result';

const maxStep = 2

export const UsersReportWizardBody = ({ onDone }: {
  onDone: (id: string) => void
}) => {
  // const {services, session, translates} = useAppContext()
  const { step} = useWizard()

  if (step === 0) {
    return <UsersReportWizardStep1  />
  } else if (step === 1) {
    return <UsersReportWizardResult />
  } else return <Spinner />
}

export const UsersReportWizard = ({ onDone }: {
  onDone: (id: string) => void
}) => {
  return <div className='usersranking-wizard'>
    <WizardProvider<WizardData> initialData={cleanWizardData()} maxStep={maxStep}>
      <UsersReportWizardBody onDone={onDone} />
    </WizardProvider>
  </div>
}

export const UsersReportWizardPopup = ({ onClose }: {
  onClose: () => void
}) => {
  return <UsersReportWizard onDone={onClose} />
}
